/* eslint-disable new-cap */
import moment from 'moment';
import {noTimeZoneShortISODate} from '../../../constants/datesFormat';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

const formatData = (data, titles, customValuesHandler = null) => {
  return data.map((row) => {
    const newRow = {};
    titles.map((key) => {
      newRow[key] = customValuesHandler ? customValuesHandler(key, row[key], row) : row[key];
    });
    return newRow;
  });
};

const generateTitles = (titles) => {
  const titleArray = titles.map((item) => {
    return item.title;
  });
  const titleItems = titles.map((item) => {
    return item.accessor;
  });
  return {titleArray, titleItems};
};

export const handleExcelReport = (dataRaw, titlesRaw, customValuesHandler = null, fileName = 'TEMS-REPORTE') => {
  const date = moment().format(noTimeZoneShortISODate);
  const {'titleArray': titles, titleItems} = generateTitles(titlesRaw);
  const data = formatData(dataRaw, titleItems, customValuesHandler);
  const ws = XLSX.utils.book_new();
  XLSX.utils.sheet_add_aoa(ws, [titles]);

  XLSX.utils.sheet_add_json(ws, data, {
    'origin': 'A2',
    'skipHeader': true,
  });

  const wb = {'Sheets': {'data': ws}, 'SheetNames': ['data']};
  const excelBuffer = XLSX.write(wb, {
    'type': 'array',
    'cellStyles': true,
  });
  const finalData = new Blob([excelBuffer], {'type': 'xlsx'});
  FileSaver.saveAs(finalData, `${fileName}-${date}.xlsx`);
};
